export default __webpack_public_path__ + "img/team-dots-1.f0e5ad71.svg";